import React, { useState } from "react"
import { Collapse, Row } from "reactstrap"
import classnames from "classnames"
import TableContainer from "components/Common/TableContainer"
import { Date } from "./createTeamCols"
import { ActiveValue } from "pages/Admin/ManageUser/ManageUserCol"
import MobileResize from "common/Resize/MobileResize"

const Accordian = props => {
  const {
    item,
    setselectedData,
    setIsEdit,
    toggle,
    sethandleAccordion,
    handleAccordion,
    keyId,
  } = props
  const [isMobile, setIsMobile] = useState(window.innerWidth < 921)

  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }
  const handleaEditAccordian = () => {
    const filterData = item?.teamMembers?.filter(el => el.active === true)
    setselectedData({ ...item, teamMembers: filterData })
    setIsEdit(true)
    toggle()
  }
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "UserName",
        accessor: "username",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Start Date",
        accessor: "startDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />
        },
      },
      {
        Header: "End Date",
        accessor: "endDate",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />
        },
      },
      {
        Header: "Reporting Person",
        accessor: "reportToName",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Active",
        accessor: "active",
        disableFilters: true,
        width: 50,
        Cell: cellProps => (
          <div style={{ paddingLeft: "10px" }}>
            <ActiveValue {...cellProps} />
          </div>
        ),
      },
    ]
    return result
  }, [])
  return (
    <React.Fragment>
      <Row>
        <div className="accordion" id="accordion" key={keyId}>
          <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingOne">
              <button
                className={classnames(
                  "accordion-button zIndexes zIndexesNo",
                  "fw-medium",
                  {
                    collapsed: handleAccordion !== keyId,
                  }
                )}
                type="button"
                onClick={() => handleOnclickAccordion(keyId)}
                style={{ cursor: "pointer" }}
              >
                {item.teamname}
              </button>
            </h2>
            <Collapse
              isOpen={handleAccordion === keyId}
              className="accordion-collapse"
            >
              <div className="accordion-body">
                <div className="text-muted table-mobileView">
                <MobileResize setIsMobile={setIsMobile}>
                  <TableContainer
                    data={item?.teamMembers || []}
                    columns={columns}
                    customPageSize={40}
                    buttonName={"Edit"}
                    isaccordian={true}
                    hidepagination={true}
                    handleaEditAccordian={handleaEditAccordian}
                  />
                   </MobileResize>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </Row>
    </React.Fragment>
  )
}

export default Accordian
